import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { useQuery } from "@tanstack/react-query";

import { FC } from "react";
import { useParams } from "react-router";

export const SyncModelEventsViewPage: FC = () => {
  const { syncModelEventId } = useParams<{ syncModelEventId: Uuid }>();

  if (!syncModelEventId) {
    return <div>Invalid ID</div>;
  }

  const result = useQuery({
    queryKey: ["sync-model-event-by-id", syncModelEventId],
    queryFn: () =>
      api.get("/internal/v1/sync-model-events/{sync_model_event_id}", {
        params: {
          path: {
            sync_model_event_id: syncModelEventId,
          },
        },
      }),
  });

  return (
    <div>
      <h1>View SyncModelEvent</h1>
      <pre>{JSON.stringify(result.data, null, 2)}</pre>
    </div>
  );
};
